import React, { FunctionComponent, useCallback } from 'react'

import { SportEntity as SportEntityType } from '@utils/entities'
import { SportCompetitor as SportCompetitorType } from '@hooks/useSportCompetitorsList'
import useSportEntities from '@hooks/useSportEntities'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import SportEntity from '@components/SportEntity'

import FollowMyTeamSportEntity from './FollowMyTeam/FollowMyTeamSportEntity'

interface SportCompetitorProps {
  competitor: SportCompetitorType
}

const SportCompetitor: FunctionComponent<SportCompetitorProps> = ({
  competitor,
}) => {
  const { sportradarId, name, image } = competitor
  const { getSportEntityBySportradarId } = useSportEntities()

  const sportEntity = getSportEntityBySportradarId(sportradarId)

  const onAddTeamClickEvent = useCallback<TrackingFnType<{ entityId: string }>>(
    ({ extraData }) => ({
      event: 'add_team',
      entity_id: extraData.entityId,
    }),
    []
  )

  const trackedOnAddTeamClick = useTracking(onAddTeamClickEvent)

  const handleOnFollowClick = useCallback(
    (sportEntity: SportEntityType) => {
      trackedOnAddTeamClick({ entityId: sportEntity.entityId })
    },
    [trackedOnAddTeamClick]
  )

  if (sportEntity) {
    return (
      <FollowMyTeamSportEntity
        sportEntity={sportEntity}
        hasLink={true}
        onFollowClick={handleOnFollowClick}
      />
    )
  }

  return <SportEntity name={name} image={image} />
}

export default SportCompetitor
